export const ItemSize = {
  getItemSize(dice, isMobile, inStrap) {
    const { size, category_type } = dice;
    const isLeatherLetter = category_type === "leatherletter";
    const StrapProportion = isMobile || isLeatherLetter ? 25 : 35;
    const PROPORTION = inStrap ? StrapProportion : (isMobile ? 25 : isLeatherLetter ? 10 : 25);

    if (!size) return { width: PROPORTION, height: PROPORTION };
    const sizes = (size.split(/[xX]+/) || []).map(x => x.replace(/ |cm/g, ""));

    const calculateSize = (itemSize) => {
        if (!itemSize) return PROPORTION;
        try {
          return (Number(itemSize) || 1) * PROPORTION;
        } catch (error) {
          return PROPORTION;
        }
    }

    return {
      width: "auto",
      height: calculateSize(sizes[1])
    }
  }
}

